import { graphql } from "gatsby"
import React from "react"
// import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Hero } from "../components/hero"
import { getImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Seo from "../components/seo"

const IndexPage = ({ data }) => {
  // data prop is passed in automatically from the 'query' var on line 46 - this only works on 'pages' though, there's a different setup for components
  const heroImage = getImage(data.heroImage)

  return (
    <Layout page="home">
      <Seo title="Home" />
      <Hero image={heroImage} title="lumberob" />

      {/* Two Column Start */}
      <div className="container two-col">
        <div className="left">
          <a
            className="shimmy-logo"
            rel="noreferrer"
            target="_blank"
            href="https://shimmy-disc.net//shimmy-2010.html"
          >
            <StaticImage
              src="../images/shimmy-logo.png"
              width={300}
              // quality={95}
              alt="A Gatsby astronaut"
            />
          </a>
        </div>

        <div className="right">
          <h2>HEY LOOK! SHIMMY-DISC</h2>
          <h3>NEW RELEASE COMING SOON</h3>
          <p>LANGUAGE LEARNER by lumberob</p>
          <a
            href="https://shimmy-disc.net//shimmy-2010.html"
            rel="noreferrer"
            target="_blank"
            className="button"
          >
            {" "}
            Shimmy-Disc
          </a>
        </div>
      </div>
      {/* Two Column End */}
    </Layout>
  )
}

export const query = graphql`
  query {
    heroImage: imageSharp(resize: { originalName: { eq: "lumber-home.jpg" } }) {
      gatsbyImageData(width: 2791)
    }
  }
`

export default IndexPage
